export const ALBUM = 'Album'
export const COMPOSER = 'Composer'
export const DOWNLOAD_HISTORY = 'Download History'
export const EDIT_PROJECT = 'Edit Project'
export const FAVOURITES = 'Favourites'
export const FIGARO = 'Figaro'
export const MUSIC_TEAM = 'Music team'
export const MIXES = 'Mixes'
export const PLAYLIST = 'Playlist'
export const SEARCH = 'Search'
export const STEMS = 'Stems'
export const TRACK_ROW = 'Track row'
export const VIEW_PROJECT = 'View Project'

export const TRACK_SOURCES = {
	ALBUM,
	COMPOSER,
	DOWNLOAD_HISTORY,
	EDIT_PROJECT,
	FAVOURITES,
	FIGARO,
	MUSIC_TEAM,
	MIXES,
	PLAYLIST,
	SEARCH,
	STEMS,
	TRACK_ROW,
	VIEW_PROJECT,
} as const

export type TrackSource = (typeof TRACK_SOURCES)[keyof typeof TRACK_SOURCES]
